import { SET_FILE_TITLE } from '../actionConstants';

export const setFileTitleAction = (payload) => {
  return {
    type: SET_FILE_TITLE,
    payload,
  };
};
